import MediaControl from './media_control'
export default MediaControl



// WEBPACK FOOTER //
// ./src/plugins/media_control/index.js